module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan gériatrie.faf548ea.svg";